import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
//import Exporting from 'highcharts/modules/exporting';

const TeamBars = (props) => {

    const questions = props?.questions;

    const options = {
        chart: {
            type: 'bar',
            height: 550,
            style: {
                fontFamily: 'Open Sans'
            }
        },
        title: {
            text: props?.title,
            y: 25,
            margin: 25
        },
        xAxis: {
            categories: questions
        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: ''
            },
        },
        legend: {
            reversed: true
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    format: '{y}%'
                }
            }
        },
        series: [{
            name: '1-2',
            data: props.hviValues.red,
            color: '#B23722',
        }, {
            name: '3-4',
            data: props.hviValues.yellow,
            color: '#E9B90F',
        }, {
            name: '5-6',
            data: props.hviValues.green,
            color: '#778441',
        }]
    }
    
    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    return (
        <div className="hvi-chart-wrap team-bar-chart mb-5">
            {props.loading &&
                <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h5 className="ps-2">Processing latest data...</h5>
                </div>
            }
            <HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
        </div>
    );
}

export default TeamBars;